import React from 'react';
import { Container, CompletionCard, CenteredContainer, T1, Description } from '../../styles/SurveyStyles';

const SurveyInvalidToken = ({ themeColors }) => {
  return (
    <Container themeColors={themeColors}>
      <CompletionCard>
        <CenteredContainer>
          <T1>Invalid Survey Link</T1>
          <Description>
            The survey link you're using appears to be invalid or has expired.
            Please contact the survey administrator for a valid link.
          </Description>
        </CenteredContainer>
      </CompletionCard>
    </Container>
  );
};

export default SurveyInvalidToken; 